import React from 'react'
import { Toaster } from "@/components/ui/sonner"


export default function MainWrapper(props) {
  const { children, fullWidth=false } = props
  return (
    <>
      <main 
        className={` ${fullWidth ? '': 'mx-auto max-w-9xl lg:container lg:mx-auto' }`}
      >
        {children}
      </main>
      <Toaster richColors/>
    </>
  )
}
